const teams = [
  {
    id: 1,
    imageUrl: "/assets/img/avatars/avatar2.jpg",
    name: "Dr. Rohit Verma",
    // designation: "IT Expert",
  },
  {
    id: 2,
    imageUrl: "/assets/img/avatars/avatar1.jpg",
    name: "Dr. Pooja Sharma",
    // designation: "Web Designer",
  },
  {
    id: 3,
    imageUrl: "/assets/img/avatars/avatar3.jpg",
    name: "Dr. Karan Malhotra",
    // designation: "Content Writer",
  },
  {
    id: 4,
    imageUrl: "/assets/img/avatars/avatar4.jpg",
    name: " Dr. Meera Nair",
    // designation: "Marketing officer",
  },
];
export {
    teams
}




